import { FC, SVGProps, ButtonHTMLAttributes, HTMLAttributes } from 'react'

export const PrimaryButton = ({
  type,
  className,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) => {
  className = 'btn' + (className ? ` ${className}` : '')

  return <button type={type || 'button'} className={className} {...props}></button>
}

export const ButtonSpinner = (props: Omit<HTMLAttributes<HTMLDivElement>, 'className'>) => {
  return <div className="button-spinner" {...props}></div>
}

export interface TPrimaryButtonWithIconProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean
  text: string
  IconComponent?: FC<SVGProps<SVGSVGElement>>
}

export const PrimaryButtonWithIcon = ({
  isLoading,
  text,
  IconComponent,
  className,
  disabled,
  ...props
}: TPrimaryButtonWithIconProps) => {
  if (!IconComponent) {
    return (
      <PrimaryButton disabled={isLoading || disabled} {...props}>
        {isLoading ? <ButtonSpinner /> : text}
      </PrimaryButton>
    )
  }

  className = 'with-icon' + (className ? ` ${className}` : '')

  return (
    <PrimaryButton className={className} disabled={isLoading || disabled} {...props}>
      <div className="inner-container">
        {!isLoading && IconComponent && (
          <div className="image-container">
            <IconComponent />
          </div>
        )}
        {isLoading ? <ButtonSpinner /> : text}
      </div>
    </PrimaryButton>
  )
}
